import {
  useCheckbox
} from "../__chunks/3CJV7UYE.js";
import {
  useCheckboxStore
} from "../__chunks/6TMY6IFR.js";
import {
  useMenuItem
} from "../__chunks/XADDW7ND.js";
import "../__chunks/W7JXAQKF.js";
import {
  MenuContext
} from "../__chunks/HVBRRKV4.js";
import "../__chunks/W5P7IKOU.js";
import "../__chunks/M5KYRTQG.js";
import "../__chunks/FVD2NJZN.js";
import "../__chunks/P4RGQGTG.js";
import "../__chunks/VFNGSUSF.js";
import "../__chunks/T3DJZG63.js";
import "../__chunks/OXPV2NBK.js";
import "../__chunks/WJ37OVG2.js";
import "../__chunks/MYID4V27.js";
import "../__chunks/BMLNRUFQ.js";
import {
  createElement,
  createHook,
  createMemoComponent
} from "../__chunks/NQJBHION.js";
import "../__chunks/P63NRZ4A.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/PNRLI7OV.js";

// src/menu/menu-item-checkbox.ts
import { useContext } from "react";
import { invariant } from "@ariakit/core/utils/misc";
var useMenuItemCheckbox = createHook(
  (_a) => {
    var _b = _a, { store, name, checked, defaultChecked, hideOnClick = false } = _b, props = __objRest(_b, ["store", "name", "checked", "defaultChecked", "hideOnClick"]);
    const context = useContext(MenuContext);
    store = store || context;
    invariant(
      store,
      process.env.NODE_ENV !== "production" && "MenuItemCheckbox must be wrapped in a MenuList or Menu component"
    );
    const checkboxStore = useCheckboxStore({
      value: store.useState((state) => state.values[name]),
      setValue: (value) => store == null ? void 0 : store.setValue(name, value)
    });
    props = __spreadValues({
      role: "menuitemcheckbox"
    }, props);
    props = useCheckbox(__spreadValues({ store: checkboxStore, checked }, props));
    props = useMenuItem(__spreadValues({ store, hideOnClick }, props));
    return props;
  }
);
var MenuItemCheckbox = createMemoComponent(
  (props) => {
    const htmlProps = useMenuItemCheckbox(props);
    return createElement("div", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  MenuItemCheckbox.displayName = "MenuItemCheckbox";
}
export {
  MenuItemCheckbox,
  useMenuItemCheckbox
};
